/**
 * MedsNMore admin icon kit (Lucide-style inline SVG).
 * Source: /home/medsnmore/laravel/resources/views/partials/icon.blade.php
 * Extra icons use the same 24×24 stroke language for Sipinor screens.
 */
export const ICON_PATHS = {
    "address-book": "<rect x=\"4\" y=\"3\" width=\"16\" height=\"18\" rx=\"2\"/><circle cx=\"12\" cy=\"10\" r=\"2.4\"/><path d=\"M8 16.2c.7-1.6 2.1-2.4 4-2.4s3.3.8 4 2.4\"/><path d=\"M8 7h.01\"/>",
    activity: "<path d=\"M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2\"/>",
    alert: "<path d=\"M12 4l9 16H3L12 4z\"/><path d=\"M12 10v4\"/><path d=\"M12 17h.01\"/>",
    "alert-circle": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M12 8v4\"/><path d=\"M12 16h.01\"/>",
    apple: "<path d=\"M16.2 12.6c0-2 1.6-3 1.7-3.1-1-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7-.6 0-1.6-.7-2.6-.7-1.3 0-2.6.8-3.3 2-1.4 2.4-.4 6 1 8 .7 1 1.5 2.1 2.5 2 .1 0 1.4-.6 2.6-.6s1.5.6 2.6.6c1.1 0 1.8-1 2.4-2 .8-1.1 1.1-2.1 1.1-2.2 0 0-2-.8-2.1-3.1z\" fill=\"currentColor\" stroke=\"none\"/><path d=\"M14 6.4c.5-.7.9-1.6.8-2.5-.8 0-1.8.5-2.4 1.2-.5.6-1 1.6-.8 2.5.9.1 1.8-.5 2.4-1.2z\" fill=\"currentColor\" stroke=\"none\"/>",
    "arrow-right": "<path d=\"M5 12h14\"/><path d=\"M13 6l6 6-6 6\"/>",
    "arrow-up": "<path d=\"M12 19V5\"/><path d=\"m5 12 7-7 7 7\"/>",
    "arrow-down": "<path d=\"M12 5v14\"/><path d=\"m19 12-7 7-7-7\"/>",
    award: "<circle cx=\"12\" cy=\"8\" r=\"6\"/><path d=\"m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526\"/>",
    "sort-asc": "<path d=\"m3 8 4-4 4 4\"/><path d=\"M7 4v16\"/><path d=\"M11 12h10\"/><path d=\"M11 16h7\"/><path d=\"M11 20h4\"/>",
    "sort-desc": "<path d=\"m3 16 4 4 4-4\"/><path d=\"M7 20V4\"/><path d=\"M11 4h10\"/><path d=\"M11 8h7\"/><path d=\"M11 12h4\"/>",
    baby: "<circle cx=\"12\" cy=\"8\" r=\"3\"/><path d=\"M6 19c.6-3 3-5 6-5s5.4 2 6 5\"/><path d=\"M9 12.5c-1.2.4-2.2 1.2-2.8 2.2\"/><path d=\"M15 12.5c1.2.4 2.2 1.2 2.8 2.2\"/>",
    badge: "<circle cx=\"12\" cy=\"8\" r=\"5.5\"/><path d=\"M8.5 13.2l-1.4 7.3 4.9-2.4 4.9 2.4-1.4-7.3\"/>",
    ban: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M5.6 5.6l12.8 12.8\"/>",
    bell: "<path d=\"M6 9a6 6 0 0 1 12 0c0 7 3 7 3 7H3s3 0 3-7\"/><path d=\"M10 19a2 2 0 0 0 4 0\"/>",
    bone: "<path d=\"M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z\"/>",
    bottle: "<path d=\"M9 4h6v3H9z\"/><path d=\"M8 7h8l1 13H7L8 7z\"/>",
    box: "<path d=\"M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z\"/><path d=\"M12 12l8-4.5\"/><path d=\"M12 12v9\"/><path d=\"M12 12L4 7.5\"/>",
    building: "<path d=\"M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18\"/><path d=\"M4 22h16\"/><path d=\"M10 6h4\"/><path d=\"M10 10h4\"/><path d=\"M10 14h4\"/><path d=\"M10 18h4\"/>",
    camera: "<path d=\"M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z\"/><circle cx=\"12\" cy=\"13\" r=\"3\"/>",
    card: "<rect x=\"3\" y=\"6\" width=\"18\" height=\"12\" rx=\"2\"/><path d=\"M3 10h18\"/><path d=\"M7 15h4\"/>",
    cart: "<circle cx=\"9\" cy=\"20\" r=\"1.2\"/><circle cx=\"18\" cy=\"20\" r=\"1.2\"/><path d=\"M3 4h2l2.2 11.2A2 2 0 0 0 9.2 17h8.4a2 2 0 0 0 2-1.6L21 8H6\"/>",
    chart: "<path d=\"M4 19h16\"/><path d=\"M7 16V10\"/><path d=\"M12 16V6\"/><path d=\"M17 16v-4\"/>",
    chat: "<path d=\"M5 18l-1.5 3 4-1.2A8.5 8.5 0 1 0 5 18z\"/>",
    check: "<path d=\"M5 12.5l4.5 4.5L19 7\"/>",
    "check-circle": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M8 12l3 3 5-6\"/>",
    chevron: "<path d=\"M9 6l6 6-6 6\"/>",
    "chevron-down": "<path d=\"M6 9l6 6 6-6\"/>",
    "chevron-left": "<path d=\"M15 18l-6-6 6-6\"/>",
    "chevron-up": "<path d=\"M18 15l-6-6-6 6\"/>",
    clipboard: "<rect x=\"6\" y=\"5\" width=\"12\" height=\"16\" rx=\"2\"/><path d=\"M9 5V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1\"/><path d=\"M9 12h6\"/><path d=\"M9 16h4\"/>",
    clock: "<circle cx=\"12\" cy=\"12\" r=\"8\"/><path d=\"M12 8v5l3 2\"/>",
    close: "<path d=\"M6 6l12 12\"/><path d=\"M18 6L6 18\"/>",
    coins: "<circle cx=\"8\" cy=\"8\" r=\"6\"/><path d=\"M18.09 10.37A6 6 0 1 1 10.34 18\"/><path d=\"M7 6h1v4\"/><path d=\"M16.7 13.9l.7.7-2.8 2.8\"/>",
    copy: "<rect x=\"8\" y=\"8\" width=\"13\" height=\"13\" rx=\"2\"/><path d=\"M4 16V4a2 2 0 0 1 2-2h12\"/>",
    cross: "<rect x=\"11\" y=\"5\" width=\"2\" height=\"14\" rx=\"1\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"5\" y=\"11\" width=\"14\" height=\"2\" rx=\"1\" fill=\"currentColor\" stroke=\"none\"/>",
    database: "<ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\"/><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\"/><path d=\"M3 12c0 1.66 4 3 9 3s9-1.34 9-3\"/>",
    "default": "<circle cx=\"12\" cy=\"12\" r=\"8\"/>",
    device: "<rect x=\"8\" y=\"3\" width=\"8\" height=\"14\" rx=\"2\"/><path d=\"M11 20h2\"/><circle cx=\"12\" cy=\"10\" r=\"1.4\"/>",
    download: "<path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/><path d=\"M7 10l5 5 5-5\"/><path d=\"M12 15V3\"/>",
    drop: "<path d=\"M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z\"/>",
    droplets: "<path d=\"M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z\"/> <path d=\"M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97\"/>",
    ethernet: "<rect x=\"9\" y=\"2\" width=\"6\" height=\"6\" rx=\"1\"/><path d=\"M12 8v3\"/><path d=\"M4 11h16\"/><rect x=\"2\" y=\"16\" width=\"4\" height=\"6\" rx=\"1\"/><rect x=\"10\" y=\"16\" width=\"4\" height=\"6\" rx=\"1\"/><rect x=\"18\" y=\"16\" width=\"4\" height=\"6\" rx=\"1\"/><path d=\"M4 16v-2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2\"/><path d=\"M12 14v2\"/>",
    "external-link": "<path d=\"M15 3h6v6\"/><path d=\"M10 14L21 3\"/><path d=\"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6\"/>",
    eye: "<path d=\"M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/>",
    "eye-off": "<path d=\"M9.88 9.88a3 3 0 1 0 4.24 4.24\"/><path d=\"M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68\"/><path d=\"M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61\"/><line x1=\"2\" y1=\"2\" x2=\"22\" y2=\"22\"/>",
    facebook: "<path d=\"M14 8h2V5h-2a4 4 0 0 0-4 4v2H8v3h2v7h3v-7h2.2l.8-3H13V9a1 1 0 0 1 1-1z\"/>",
    file: "<path d=\"M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z\"/><path d=\"M14 3v5h5\"/>",
    "file-x": "<path d=\"M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z\"/><path d=\"M14 3v5h5\"/><path d=\"m14.5 12.5-5 5\"/><path d=\"m9.5 12.5 5 5\"/>",
    food: "<path d=\"M4 11h16v2a8 8 0 0 1-16 0v-2z\"/><path d=\"M7 11V6\"/><path d=\"M12 11V5\"/><path d=\"M17 11V7\"/>",
    globe: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M3 12h18\"/><path d=\"M12 3a14.5 14.5 0 0 0 0 18 14.5 14.5 0 0 0 0-18\"/>",
    grid: "<rect x=\"4\" y=\"4\" width=\"7\" height=\"7\" rx=\"1.5\"/><rect x=\"13\" y=\"4\" width=\"7\" height=\"7\" rx=\"1.5\"/><rect x=\"4\" y=\"13\" width=\"7\" height=\"7\" rx=\"1.5\"/><rect x=\"13\" y=\"13\" width=\"7\" height=\"7\" rx=\"1.5\"/>",
    hand: "<path d=\"M18 11V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2\"/> <path d=\"M14 10V4a2 2 0 0 0-2-2 2 2 0 0 0-2 2v2\"/> <path d=\"M10 10.5V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2v8\"/> <path d=\"M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15\"/>",
    headset: "<path d=\"M4 14v-2a8 8 0 0 1 16 0v2\"/><path d=\"M4 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2z\"/><path d=\"M20 14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z\"/>",
    heart: "<path d=\"M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5\"/>",
    "help-circle": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4\"/><path d=\"M12 17h.01\"/>",
    home: "<path d=\"M4 11.5L12 5l8 6.5\"/><path d=\"M6 10.5V19h12v-8.5\"/>",
    hourglass: "<path d=\"M6 2h12\"/><path d=\"M6 22h12\"/><path d=\"M8 2v5l4 5 4-5V2\"/><path d=\"M8 22v-5l4-5 4 5v5\"/>",
    image: "<rect x=\"4\" y=\"5\" width=\"16\" height=\"14\" rx=\"2\"/><circle cx=\"9\" cy=\"10\" r=\"1.5\"/><path d=\"M4 16l4.5-4 3.5 3.5L16 12l4 4\"/>",
    inbox: "<path d=\"M22 12h-6l-2 3h-4l-2-3H2\"/><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"/>",
    info: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M12 16v-4\"/><path d=\"M12 8h.01\"/>",
    instagram: "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"4\"/><circle cx=\"12\" cy=\"12\" r=\"3.5\"/><circle cx=\"17.2\" cy=\"6.8\" r=\"0.8\" fill=\"currentColor\" stroke=\"none\"/>",
    key: "<circle cx=\"7.5\" cy=\"15.5\" r=\"5.5\"/><path d=\"m21 2-9.6 9.6\"/><path d=\"m15.5 7.5 3 3\"/>",
    kidney: "<path d=\"M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z\"/> <path d=\"M5.341 10.62a4 4 0 1 0 5.279-5.28\"/>",
    layers: "<path d=\"M12 3l9 5-9 5-9-5 9-5z\"/><path d=\"M3 13l9 5 9-5\"/><path d=\"M3 17l9 5 9-5\"/>",
    leaf: "<path d=\"M5 19c8-1 13-8 14-15-7 1-14 6-14 15z\"/><path d=\"M8 14c2-1 5-4 7-7\"/>",
    link: "<path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"/><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"/>",
    linkedin: "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\"/><path d=\"M8 10v7\"/><circle cx=\"8\" cy=\"7.5\" r=\"1.1\" fill=\"currentColor\" stroke=\"none\"/><path d=\"M12 17v-4.2c0-1.2.8-2 1.9-2 1 0 1.6.7 1.6 2V17\"/><path d=\"M12 12.5V10\"/>",
    list: "<path d=\"M8 6h13\"/><path d=\"M8 12h13\"/><path d=\"M8 18h13\"/><path d=\"M3 6h.01\"/><path d=\"M3 12h.01\"/><path d=\"M3 18h.01\"/>",
    liver: "<path d=\"M4 13.5C4 8.8 7.6 5.5 12 5.5c1.8 0 3.2.7 5 2 1.4 1 3 1.6 4.4 1.6.9 0 1.6.7 1.6 1.7C23 16.2 19.2 21 13.2 21 7.5 21 4 17.4 4 13.5z\"/> <path d=\"M12 5.5c.3 2.6 1.8 4.8 4.2 6.2\"/>",
    lock: "<rect x=\"5\" y=\"11\" width=\"14\" height=\"10\" rx=\"2\"/><path d=\"M8 11V8a4 4 0 0 1 8 0v3\"/>",
    logout: "<path d=\"M10 17l-5-5 5-5\"/><path d=\"M5 12h11\"/><path d=\"M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3\"/>",
    lungs: "<path d=\"M6.081 20c1.612 0 2.919-1.335 2.919-2.98V7.257c0-.694-.552-1.257-1.232-1.257-.205 0-.405.052-.584.15l-.13.083c-1.46 1.059-2.432 2.647-3.404 5.824-.42 1.37-.636 2.962-.648 4.775-.012 1.675 1.261 3.054 2.877 3.161l.203.007\"/> <path d=\"M17.92 20c-1.613 0-2.92-1.335-2.92-2.98V7.257c0-.694.552-1.257 1.233-1.257.204 0 .405.052.584.15l.13.083c1.46 1.059 2.432 2.647 3.405 5.824.42 1.37.636 2.962.648 4.775.012 1.675-1.261 3.054-2.878 3.161l-.202.007\"/> <path d=\"M9 12a3 3 0 0 0 3-3 3 3 0 0 0 3 3\"/> <path d=\"M12 4v5\"/>",
    mail: "<rect x=\"3\" y=\"5\" width=\"18\" height=\"14\" rx=\"2\"/><path d=\"M3 7l9 7 9-7\"/>",
    menu: "<path d=\"M4 7h16\"/><path d=\"M4 12h16\"/><path d=\"M4 17h16\"/>",
    monitor: "<rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\"/><path d=\"M8 21h8\"/><path d=\"M12 17v4\"/>",
    moon: "<path d=\"M20 14.5A7.5 7.5 0 0 1 9.5 4 8 8 0 1 0 20 14.5z\"/>",
    "more-horizontal": "<circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"19\" cy=\"12\" r=\"1\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"5\" cy=\"12\" r=\"1\" fill=\"currentColor\" stroke=\"none\"/>",
    pause: "<rect x=\"6\" y=\"4\" width=\"4\" height=\"16\" rx=\"1\"/><rect x=\"14\" y=\"4\" width=\"4\" height=\"16\" rx=\"1\"/>",
    paw: "<circle cx=\"7\" cy=\"9\" r=\"1.6\"/><circle cx=\"12\" cy=\"7\" r=\"1.6\"/><circle cx=\"17\" cy=\"9\" r=\"1.6\"/><ellipse cx=\"12\" cy=\"16\" rx=\"4.2\" ry=\"3.2\"/>",
    pencil: "<path d=\"M12 20h9\"/><path d=\"M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z\"/>",
    percent: "<circle cx=\"8\" cy=\"8\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M18 6L6 18\"/>",
    phone: "<path d=\"M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8.1 9.5a16 16 0 0 0 6.4 6.4l1.1-1.1a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6A2 2 0 0 1 22 16.9z\"/>",
    pill: "<rect x=\"3.5\" y=\"8.5\" width=\"17\" height=\"7\" rx=\"3.5\" transform=\"rotate(-35 12 12)\"/><path d=\"M9.2 9.8l5 5\"/>",
    play: "<path d=\"M5 3.8v16.4l13.2-8.2L5 3.8z\" fill=\"currentColor\" stroke=\"none\"/>",
    plus: "<path d=\"M12 5v14\"/><path d=\"M5 12h14\"/>",
    printer: "<path d=\"M6 9V4h12v5\"/><path d=\"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2\"/><rect x=\"6\" y=\"14\" width=\"12\" height=\"6\" rx=\"1\"/>",
    receipt: "<path d=\"M4 2v20l3-1.5 3 1.5 3-1.5 3 1.5 3-1.5 3 1.5V2l-3 1.5L16 2l-3 1.5L10 2 7 3.5 4 2z\"/><path d=\"M8 8h8\"/><path d=\"M8 12h8\"/><path d=\"M8 16h5\"/>",
    "return": "<path d=\"M9 7H5V3\"/><path d=\"M5 7a8 8 0 1 1-1.2 6\"/>",
    rupee: "<path d=\"M7 6h10\"/><path d=\"M7 10h10\"/><path d=\"M11 6c3 0 5 1.5 5 4s-2 4-5 4H9l6 6\"/><path d=\"M7 14h4\"/>",
    school: "<path d=\"M22 10L12 4 2 10l10 6 10-6z\"/><path d=\"M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5\"/><path d=\"M22 10v6\"/>",
    search: "<circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"M20 20l-3.2-3.2\"/>",
    "search-x": "<circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"M20 20l-3.2-3.2\"/><path d=\"m8.2 8.2 5.6 5.6\"/><path d=\"m13.8 8.2-5.6 5.6\"/>",
    send: "<path d=\"m22 2-7 20-4-9-9-4z\"/><path d=\"M22 2 11 13\"/>",
    server: "<rect x=\"2\" y=\"2\" width=\"20\" height=\"8\" rx=\"2\"/><rect x=\"2\" y=\"14\" width=\"20\" height=\"8\" rx=\"2\"/><path d=\"M6 6h.01\"/><path d=\"M6 18h.01\"/>",
    settings: "<circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M12 3v2\"/><path d=\"M12 19v2\"/><path d=\"M4.9 4.9l1.4 1.4\"/><path d=\"M17.7 17.7l1.4 1.4\"/><path d=\"M3 12h2\"/><path d=\"M19 12h2\"/><path d=\"M4.9 19.1l1.4-1.4\"/><path d=\"M17.7 6.3l1.4-1.4\"/>",
    share: "<circle cx=\"18\" cy=\"5\" r=\"3\"/><circle cx=\"6\" cy=\"12\" r=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><path d=\"m8.6 13.5 6.8 4\"/><path d=\"m15.4 6.5-6.8 4\"/>",
    shield: "<path d=\"M12 3l8 3v6c0 5-3.4 8.4-8 9.5C7.4 20.4 4 17 4 12V6l8-3z\"/><path d=\"M9 12l2 2 4-4\"/>",
    sliders: "<path d=\"M4 7h10\"/><circle cx=\"16\" cy=\"7\" r=\"2\"/><path d=\"M18 7h2\"/><path d=\"M4 17h4\"/><circle cx=\"10\" cy=\"17\" r=\"2\"/><path d=\"M12 17h8\"/>",
    spark: "<path d=\"M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z\"/> <path d=\"M20 2v4\"/><path d=\"M22 4h-4\"/><circle cx=\"4\" cy=\"20\" r=\"2\"/>",
    star: "<path d=\"M12 3.4l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 16.7 7.2 18.3l.9-5.4-3.9-3.8 5.4-.8L12 3.4z\" fill=\"currentColor\" stroke=\"none\"/>",
    stomach: "<path d=\"M9.5 2.5v5\"/> <path d=\"M9.5 7.5c-3.8 1.2-6 4.5-5.8 8.2.2 3.5 2.8 5.8 6.3 5.8 4.5 0 7.5-3 8-6.8.4-3.2-1-6.2-3.5-7.8-1.5-1-3.2-1.5-5-1.4\"/> <path d=\"M8 14.5c2.5 1.3 6 1.3 8.5 0\"/>",
    sun: "<circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M12 2v2\"/><path d=\"M12 20v2\"/><path d=\"M4.9 4.9l1.4 1.4\"/><path d=\"M17.7 17.7l1.4 1.4\"/><path d=\"M2 12h2\"/><path d=\"M20 12h2\"/><path d=\"M4.9 19.1l1.4-1.4\"/><path d=\"M17.7 6.3l1.4-1.4\"/>",
    "sun-morning": "<path d=\"M12 2v8\"/><path d=\"m4.93 10.93 1.41 1.41\"/><path d=\"M2 18h2\"/><path d=\"M20 18h2\"/><path d=\"m19.07 10.93-1.41 1.41\"/><path d=\"M22 22H2\"/><path d=\"m8 6 4-4 4 4\"/><path d=\"M16 18a4 4 0 0 0-8 0\"/>",
    "cloud-sun": "<path d=\"M12 2v2\"/><path d=\"m4.93 4.93 1.41 1.41\"/><path d=\"M20 12h2\"/><path d=\"m19.07 4.93-1.41 1.41\"/><path d=\"M15.947 12.227A4 4 0 0 0 9 14.001H8a5 5 0 0 0 0 10h8a4 4 0 0 0 .947-7.773\"/><path d=\"M12 8a2.5 2.5 0 0 1 4.31 1.147\"/>",
    tag: "<path d=\"M20 12l-8 8-9-9V4h7l10 8z\"/><circle cx=\"7.5\" cy=\"7.5\" r=\"1.2\" fill=\"currentColor\" stroke=\"none\"/>",
    trash: "<path d=\"M4 7h16\"/><path d=\"M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2\"/><path d=\"M6 7l1 13h10l1-13\"/><path d=\"M10 11v6\"/><path d=\"M14 11v6\"/>",
    "trending-up": "<path d=\"M22 7l-8.5 8.5-5-5L2 17\"/><path d=\"M16 7h6v6\"/>",
    truck: "<path d=\"M3 7h11v10H3z\"/><path d=\"M14 10h4l3 3v4h-7\"/><circle cx=\"7\" cy=\"18.5\" r=\"1.5\"/><circle cx=\"17.5\" cy=\"18.5\" r=\"1.5\"/>",
    twitter: "<path d=\"M5 5l5.8 7.4L5.4 19h2.2l4.2-4.9L16.4 19H19l-6-7.6L18.5 5H16.3l-3.9 4.6L8.2 5H5z\" fill=\"currentColor\" stroke=\"none\"/>",
    upload: "<path d=\"M12 16V6\"/><path d=\"M8 10l4-4 4 4\"/><path d=\"M4 18h16\"/>",
    user: "<circle cx=\"12\" cy=\"8\" r=\"3.2\"/><path d=\"M5 19.2a7 7 0 0 1 14 0\"/>",
    users: "<circle cx=\"9\" cy=\"8\" r=\"3\"/><path d=\"M3 19a6 6 0 0 1 12 0\"/><circle cx=\"17\" cy=\"9\" r=\"2.2\"/><path d=\"M16 19c1.5-.4 3.2-1.5 4-3.5\"/>",
    whatsapp: "<path fill=\"currentColor\" stroke=\"none\" d=\"M12.04 2.04c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.04 22l5.25-1.38c1.45.79 3.08 1.21 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.86 9.86 0 0 0 12.04 2.04zm0 18.18h-.01c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.27 8.27 0 0 1-1.27-4.41c0-4.57 3.72-8.29 8.3-8.29 2.22 0 4.3.86 5.86 2.43a8.25 8.25 0 0 1 2.43 5.87c-.01 4.57-3.73 8.26-8.32 8.26zm4.56-6.21c-.25-.12-1.47-.73-1.7-.81-.23-.08-.4-.12-.56.13-.17.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07s.89 2.41 1.02 2.58c.12.17 1.76 2.68 4.26 3.76.6.26 1.06.41 1.42.52.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.06-.1-.23-.17-.48-.29z\"/>",
    "x-circle": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M15 9l-6 6\"/><path d=\"M9 9l6 6\"/>",
    book: "<path d=\"M4 19.5A2.5 2.5 0 0 1 6.5 17H20\"/><path d=\"M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z\"/>",
    calendar: "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M16 2v4\"/><path d=\"M8 2v4\"/><path d=\"M3 10h18\"/>",
    folder: "<path d=\"M3 7h6l2 2h10v11H3z\"/>",
    "map-pin": "<path d=\"M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z\"/><circle cx=\"12\" cy=\"10\" r=\"3\"/>",
    wrench: "<path d=\"M14.7 6.3a4.1 4.1 0 0 0-5.8 5.8L3 18l3 3 5.9-5.9a4.1 4.1 0 0 0 5.8-5.8l-3 3-2-2 3-3z\"/>",
    youtube: "<rect x=\"3\" y=\"7\" width=\"18\" height=\"10\" rx=\"3\"/><path d=\"M11 10l5 2-5 2v-4z\" fill=\"currentColor\" stroke=\"none\"/>",
    "book-open": "<path d=\"M2 4h8a4 4 0 0 1 4 4v12a3.2 3.2 0 0 0-3.2-3.2H2z\"/><path d=\"M22 4h-8a4 4 0 0 0-4 4v12a3.2 3.2 0 0 1 3.2-3.2H22z\"/>",
    briefcase: "<rect x=\"3\" y=\"7\" width=\"18\" height=\"13\" rx=\"2\"/><path d=\"M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/><path d=\"M3 13h18\"/>",
    bus: "<path d=\"M6 4h12a2 2 0 0 1 2 2v11H4V6a2 2 0 0 1 2-2z\"/><path d=\"M4 17h3v2H4z\"/><path d=\"M17 17h3v2h-3z\"/><path d=\"M8 11h3\"/><path d=\"M13 11h3\"/><path d=\"M6 8h12\"/>",
    "calendar-check": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M16 2v4\"/><path d=\"M8 2v4\"/><path d=\"M3 10h18\"/><path d=\"M9 16l2 2 4-4\"/>",
    "clipboard-check": "<rect x=\"6\" y=\"5\" width=\"12\" height=\"16\" rx=\"2\"/><path d=\"M9 5V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1\"/><path d=\"M9 13l2 2 4-4\"/>",
    "clipboard-list": "<rect x=\"6\" y=\"5\" width=\"12\" height=\"16\" rx=\"2\"/><path d=\"M9 5V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1\"/><path d=\"M9 11h6\"/><path d=\"M9 15h4\"/>",
    "door-open": "<path d=\"M13 4h5v16h-5\"/><path d=\"M6 20V8l7-4v16\"/><path d=\"M9.5 12h.01\"/>",
    "file-text": "<path d=\"M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z\"/><path d=\"M14 3v5h5\"/><path d=\"M9 13h6\"/><path d=\"M9 17h4\"/>",
    "file-search": "<path d=\"M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z\"/><path d=\"M14 3v5h5\"/><circle cx=\"11.25\" cy=\"15.25\" r=\"2.4\"/><path d=\"M13.1 17.1 15.4 19.4\"/>",
    "folder-open": "<path d=\"M3 7h6l2 2h10v3H3z\"/><path d=\"M3 12l2 8h14l2-8\"/>",
    "graduation-cap": "<path d=\"M22 10L12 5 2 10l10 5 10-5z\"/><path d=\"M6 12v4.5c0 1.5 2.7 3 6 3s6-1.5 6-3V12\"/><path d=\"M22 10v6\"/>",
    hash: "<path d=\"M4 9h16\"/><path d=\"M4 15h16\"/><path d=\"M10 3L8 21\"/><path d=\"M16 3l-2 18\"/>",
    "id-card": "<rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"2\"/><circle cx=\"8.5\" cy=\"12\" r=\"2\"/><path d=\"M13 10h5\"/><path d=\"M13 14h3.5\"/>",
    languages: "<path d=\"M4 5h7\"/><path d=\"M7.5 3v2\"/><path d=\"M4 9s1.5 4 5.5 4\"/><path d=\"M9.5 5c-.4 2.2-1.6 4.2-3.5 5.6\"/><path d=\"M14 13l4 8\"/><path d=\"M18 13l4 8\"/><path d=\"M15.2 19h5.6\"/>",
    megaphone: "<path d=\"M3 11v2a2 2 0 0 0 2 2h1l6 5V4L6 9H5a2 2 0 0 0-2 2z\"/><path d=\"M15.5 8.5a4.5 4.5 0 0 1 0 7\"/>",
    newspaper: "<path d=\"M4 5h11a2 2 0 0 1 2 2v12H6a2 2 0 0 1-2-2V5z\"/><path d=\"M17 9h3v10a2 2 0 0 1-2 2h-1\"/><path d=\"M7 9h6\"/><path d=\"M7 13h6\"/><path d=\"M7 17h4\"/>",
    "qr-code": "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"/><path d=\"M14 14h3v3h-3z\"/><path d=\"M18 14h3\"/><path d=\"M14 18h.01\"/><path d=\"M18 18h3v3h-3z\"/>",
    refresh: "<path d=\"M21 12a9 9 0 1 1-2.2-5.8\"/><path d=\"M21 4v6h-6\"/>",
    route: "<circle cx=\"6\" cy=\"19\" r=\"2.5\"/><circle cx=\"18\" cy=\"5\" r=\"2.5\"/><path d=\"M12 19h4.5a3.5 3.5 0 0 0 0-7H9.5a3.5 3.5 0 0 1 0-7H14\"/>",
    scan: "<path d=\"M4 8V5a1 1 0 0 1 1-1h3\"/><path d=\"M16 4h3a1 1 0 0 1 1 1v3\"/><path d=\"M20 16v3a1 1 0 0 1-1 1h-3\"/><path d=\"M8 20H5a1 1 0 0 1-1-1v-3\"/><path d=\"M4 12h16\"/>",
    trophy: "<path d=\"M8 5h8v5a4 4 0 0 1-8 0V5z\"/><path d=\"M8 5H5a2 2 0 0 0 2 4\"/><path d=\"M16 5h3a2 2 0 0 1-2 4\"/><path d=\"M12 14v3\"/><path d=\"M8 20h8\"/>",
    utensils: "<path d=\"M4 3v8a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V3\"/><path d=\"M6 13v8\"/><path d=\"M16 3c0 4 3 5 3 9v9\"/><path d=\"M16 3v9\"/>",
    "user-check": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M16 11l2 2 4-4\"/>",
    "user-minus": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M22 11h-6\"/>",
    "user-plus": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M19 8v6\"/><path d=\"M22 11h-6\"/>",
    video: "<rect x=\"3\" y=\"6\" width=\"13\" height=\"12\" rx=\"2\"/><path d=\"M16 10.5l5-3v9l-5-3z\"/>",
    wallet: "<rect x=\"3\" y=\"6\" width=\"18\" height=\"14\" rx=\"2\"/><path d=\"M3 10h18\"/><path d=\"M16 15h2\"/>",
    wifi: "<path d=\"M5 12.5a11 11 0 0 1 14 0\"/><path d=\"M8.5 16a6 6 0 0 1 7 0\"/><path d=\"M12 20h.01\"/>",
    bed: "<path d=\"M3 18V9a2 2 0 0 1 2-2h6v7\"/><path d=\"M11 14h10v4\"/><path d=\"M3 18h18\"/><path d=\"M19 14V9a2 2 0 0 0-2-2h-6\"/>",
    palette: "<circle cx=\"13.5\" cy=\"6.5\" r=\".5\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"17.5\" cy=\"10.5\" r=\".5\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"8.5\" cy=\"7.5\" r=\".5\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"6.5\" cy=\"12.5\" r=\".5\" fill=\"currentColor\" stroke=\"none\"/><path d=\"M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.992 6.5 17.5 2 12 2z\"/>",
    crown: "<path d=\"M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z\"/><path d=\"M5 21h14\"/>",
    library: "<path d=\"m16 6 4 14\"/><path d=\"M12 6v14\"/><path d=\"M8 8v12\"/><path d=\"M4 4v16\"/>",
    landmark: "<path d=\"M10 18v-7\"/><path d=\"M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.52.254.52 1.05 0 1.305l-7.866 3.847a2 2 0 0 1-1.76.006L3.354 7.356c-.52-.254-.52-1.05 0-1.305z\"/><path d=\"M14 18v-7\"/><path d=\"M18 18v-7\"/><path d=\"M3 22h18\"/><path d=\"M6 18v-7\"/>",
    accessibility: "<circle cx=\"16\" cy=\"4\" r=\"1\"/><path d=\"m18 19 1-7-6 1\"/><path d=\"m5 8 3-3 5.5 3-2.36 3.5\"/><path d=\"M4.24 14.5a5 5 0 0 0 6.88 6\"/><path d=\"M13.76 17.5a5 5 0 0 0-6.88-6\"/>",
};

export const ICON_ALIASES = {
    "address-book": "address-book",
    activity: "activity",
    alert: "alert",
    "alert-circle": "alert-circle",
    "alert-triangle": "alert",
    "angle-small-down": "chevron-down",
    apple: "apple",
    apps: "grid",
    "arrow-right": "arrow-right",
    "arrow-up": "arrow-up",
    "arrow-down": "arrow-down",
    "sort-asc": "sort-asc",
    "sort-desc": "sort-desc",
    "sort-alpha-down": "sort-asc",
    "sort-alpha-up": "sort-desc",
    "arrow-small-left": "chevron-left",
    "arrow-small-right": "chevron",
    "arrow-up-right-from-square": "external-link",
    award: "award",
    baby: "baby",
    badge: "badge",
    ban: "ban",
    bell: "bell",
    bone: "bone",
    bottle: "bottle",
    box: "box",
    building: "building",
    camera: "camera",
    card: "card",
    "caret-down": "chevron-down",
    "caret-up": "chevron-up",
    cart: "cart",
    chart: "chart",
    "chart-simple": "chart",
    chat: "chat",
    check: "check",
    "check-circle": "check-circle",
    chevron: "chevron",
    "chevron-down": "chevron-down",
    "chevron-left": "chevron-left",
    "chevron-up": "chevron-up",
    "circle-user": "user",
    clipboard: "clipboard",
    clock: "clock",
    close: "close",
    "cloud-upload-alt": "upload",
    coins: "rupee",
    "comment-question": "chat",
    copy: "copy",
    "credit-card": "card",
    cross: "cross",
    "cross-circle": "x-circle",
    "cross-small": "close",
    cube: "box",
    database: "database",
    "default": "default",
    "desktop-wallpaper": "monitor",
    device: "device",
    document: "file",
    download: "download",
    drop: "drop",
    droplets: "droplets",
    edit: "pencil",
    envelope: "mail",
    ethernet: "ethernet",
    "external-link": "external-link",
    eye: "eye",
    "eye-alt": "eye",
    "eye-off": "eye-off",
    "eye-slash": "eye-off",
    "ni-eye": "file-search",
    "ni-eye-alt": "file-search",
    view: "file-search",
    "file-search": "file-search",
    facebook: "facebook",
    "fi-address-book": "address-book",
    "fi-angle-small-down": "chevron-down",
    "fi-apps": "grid",
    "fi-arrow-right": "arrow-right",
    "fi-arrow-small-left": "chevron-left",
    "fi-arrow-small-right": "chevron",
    "fi-arrow-up-right-from-square": "external-link",
    "fi-badge": "badge",
    "fi-bell": "bell",
    "fi-building": "building",
    "fi-camera": "camera",
    "fi-caret-down": "chevron-down",
    "fi-caret-up": "chevron-up",
    "fi-chart-simple": "chart",
    "fi-check": "check",
    "fi-check-circle": "check-circle",
    "fi-circle-user": "user",
    "fi-clock": "clock",
    "fi-cloud-upload-alt": "upload",
    "fi-coins": "rupee",
    "fi-comment-question": "chat",
    "fi-copy": "copy",
    "fi-credit-card": "card",
    "fi-cross-circle": "x-circle",
    "fi-cross-small": "close",
    "fi-cube": "box",
    "fi-database": "database",
    "fi-desktop-wallpaper": "monitor",
    "fi-document": "file",
    "fi-download": "download",
    "fi-edit": "pencil",
    "fi-envelope": "mail",
    "fi-ethernet": "ethernet",
    "fi-eye": "eye",
    "fi-eye-alt": "eye",
    "fi-file-pdf": "file",
    "fi-filter": "sliders",
    "fi-globe": "globe",
    "fi-headset": "headset",
    "fi-home": "home",
    "fi-hourglass": "hourglass",
    "fi-inbox-in": "inbox",
    "fi-info": "info",
    "fi-interrogation": "help-circle",
    "fi-key": "key",
    "fi-layers": "layers",
    "fi-link": "link",
    "fi-list": "list",
    "fi-lock": "lock",
    "fi-moon": "moon",
    "fi-paper-plane": "send",
    "fi-pause": "pause",
    "fi-pencil": "pencil",
    "fi-picture": "image",
    "fi-plus-small": "plus",
    "fi-portrait": "user",
    "fi-print": "printer",
    "fi-receipt": "receipt",
    "fi-rr-address-book": "address-book",
    "fi-rr-angle-small-down": "chevron-down",
    "fi-rr-apps": "grid",
    "fi-rr-arrow-right": "arrow-right",
    "fi-rr-arrow-small-left": "chevron-left",
    "fi-rr-arrow-small-right": "chevron",
    "fi-rr-arrow-up-right-from-square": "external-link",
    "fi-rr-badge": "badge",
    "fi-rr-bell": "bell",
    "fi-rr-building": "building",
    "fi-rr-camera": "camera",
    "fi-rr-caret-down": "chevron-down",
    "fi-rr-caret-up": "chevron-up",
    "fi-rr-chart-simple": "chart",
    "fi-rr-check": "check",
    "fi-rr-check-circle": "check-circle",
    "fi-rr-circle-user": "user",
    "fi-rr-clock": "clock",
    "fi-rr-cloud-upload-alt": "upload",
    "fi-rr-coins": "rupee",
    "fi-rr-comment-question": "chat",
    "fi-rr-copy": "copy",
    "fi-rr-credit-card": "card",
    "fi-rr-cross-circle": "x-circle",
    "fi-rr-cross-small": "close",
    "fi-rr-cube": "box",
    "fi-rr-database": "database",
    "fi-rr-desktop-wallpaper": "monitor",
    "fi-rr-document": "file",
    "fi-rr-download": "download",
    "fi-rr-edit": "pencil",
    "fi-rr-envelope": "mail",
    "fi-rr-ethernet": "ethernet",
    "fi-rr-eye": "eye",
    "fi-rr-eye-alt": "eye",
    "fi-rr-file-pdf": "file",
    "fi-rr-filter": "sliders",
    "fi-rr-globe": "globe",
    "fi-rr-headset": "headset",
    "fi-rr-home": "home",
    "fi-rr-hourglass": "hourglass",
    "fi-rr-inbox-in": "inbox",
    "fi-rr-info": "info",
    "fi-rr-interrogation": "help-circle",
    "fi-rr-key": "key",
    "fi-rr-layers": "layers",
    "fi-rr-link": "link",
    "fi-rr-list": "list",
    "fi-rr-lock": "lock",
    "fi-rr-moon": "moon",
    "fi-rr-paper-plane": "send",
    "fi-rr-pause": "pause",
    "fi-rr-pencil": "pencil",
    "fi-rr-picture": "image",
    "fi-rr-plus-small": "plus",
    "fi-rr-portrait": "user",
    "fi-rr-print": "printer",
    "fi-rr-receipt": "receipt",
    "fi-rr-school": "school",
    "fi-rr-search": "search",
    "fi-rr-settings": "settings",
    "fi-rr-share": "share",
    "fi-rr-shield-check": "shield",
    "fi-rr-sign-out-alt": "logout",
    "fi-rr-sparkles": "spark",
    "fi-rr-star": "star",
    "fi-rr-sun": "sun",
    "fi-rr-time-fast": "clock",
    "fi-rr-trash": "trash",
    "fi-rr-upload": "upload",
    "fi-rr-user": "user",
    "fi-rr-users": "users",
    "fi-school": "school",
    "fi-search": "search",
    "fi-settings": "settings",
    "fi-share": "share",
    "fi-shield-check": "shield",
    "fi-sign-out-alt": "logout",
    "fi-sparkles": "spark",
    "fi-star": "star",
    "fi-sun": "sun",
    "fi-time-fast": "clock",
    "fi-trash": "trash",
    "fi-upload": "upload",
    "fi-user": "user",
    "fi-users": "users",
    file: "file",
    "file-pdf": "file",
    filter: "sliders",
    food: "food",
    globe: "globe",
    grid: "grid",
    hand: "hand",
    headset: "headset",
    heart: "heart",
    "help-circle": "help-circle",
    home: "home",
    hourglass: "hourglass",
    image: "image",
    inbox: "inbox",
    "inbox-in": "inbox",
    info: "info",
    instagram: "instagram",
    interrogation: "help-circle",
    key: "key",
    kidney: "kidney",
    layers: "layers",
    leaf: "leaf",
    link: "link",
    linkedin: "linkedin",
    list: "list",
    liver: "liver",
    lock: "lock",
    logout: "logout",
    lungs: "lungs",
    mail: "mail",
    menu: "menu",
    monitor: "monitor",
    moon: "moon",
    "more-horizontal": "more-horizontal",
    "more-h": "more-horizontal",
    "paper-plane": "send",
    pause: "pause",
    paw: "paw",
    pencil: "pencil",
    percent: "percent",
    phone: "phone",
    picture: "image",
    pill: "pill",
    play: "play",
    plus: "plus",
    "plus-small": "plus",
    portrait: "user",
    print: "printer",
    printer: "printer",
    receipt: "receipt",
    "return": "return",
    rupee: "rupee",
    school: "school",
    search: "search",
    send: "send",
    server: "server",
    settings: "settings",
    share: "share",
    shield: "shield",
    "shield-check": "shield",
    "sign-out-alt": "logout",
    sliders: "sliders",
    spark: "spark",
    sparkles: "spark",
    star: "star",
    stomach: "stomach",
    sun: "sun",
    "sun-morning": "sun-morning",
    sunrise: "sun-morning",
    "cloud-sun": "cloud-sun",
    "sun-cloud": "cloud-sun",
    tag: "tag",
    "time-fast": "clock",
    trash: "trash",
    "trending-up": "trending-up",
    truck: "truck",
    twitter: "twitter",
    upload: "upload",
    user: "user",
    users: "users",
    "layout-grid": "grid",
    landmark: "landmark",
    accessibility: "accessibility",
    "fi-rr-landmark": "landmark",
    "fi-landmark": "landmark",
    "fi-rr-accessibility": "accessibility",
    "fi-accessibility": "accessibility",
    whatsapp: "whatsapp",
    "x-circle": "x-circle",
    youtube: "youtube",
    "admin": "shield",
    "fi-rr-admin": "shield",
    "fi-admin": "shield",
    "arrow-trend-up": "trending-up",
    "fi-rr-arrow-trend-up": "trending-up",
    "fi-arrow-trend-up": "trending-up",
    "barcode": "tag",
    "fi-rr-barcode": "tag",
    "fi-barcode": "tag",
    "beacon": "bell",
    "fi-rr-beacon": "bell",
    "fi-beacon": "bell",
    "blog-text": "file",
    "fi-rr-blog-text": "file",
    "fi-blog-text": "file",
    "fi-rr-book": "book",
    "fi-book": "book",
    "book-bookmark": "book",
    "fi-rr-book-bookmark": "book",
    "fi-book-bookmark": "book",
    "book-open-reader": "book",
    "fi-rr-book-open-reader": "book",
    "fi-book-open-reader": "book",
    "browser": "globe",
    "fi-rr-browser": "globe",
    "fi-browser": "globe",
    "fi-rr-calendar": "calendar",
    "fi-calendar": "calendar",
    "calendar-check": "check-circle",
    "fi-rr-calendar-check": "check-circle",
    "fi-calendar-check": "check-circle",
    "calendar-day": "calendar",
    "fi-rr-calendar-day": "calendar",
    "fi-calendar-day": "calendar",
    "calendar-days": "calendar",
    "fi-rr-calendar-days": "calendar",
    "fi-calendar-days": "calendar",
    "calendar-star": "star",
    "fi-rr-calendar-star": "star",
    "fi-calendar-star": "star",
    "calendar-xmark": "calendar",
    "fi-rr-calendar-xmark": "calendar",
    "fi-calendar-xmark": "calendar",
    "certificate": "badge",
    "fi-rr-certificate": "badge",
    "fi-certificate": "badge",
    "chalkboard": "school",
    "fi-rr-chalkboard": "school",
    "fi-chalkboard": "school",
    "chalkboard-user": "user",
    "fi-rr-chalkboard-user": "user",
    "fi-chalkboard-user": "user",
    "chart-histogram": "chart",
    "fi-rr-chart-histogram": "chart",
    "fi-chart-histogram": "chart",
    "chart-network": "chart",
    "fi-rr-chart-network": "chart",
    "fi-chart-network": "chart",
    "chart-pie": "chart",
    "fi-rr-chart-pie": "chart",
    "fi-chart-pie": "chart",
    "church": "building",
    "fi-rr-church": "building",
    "fi-church": "building",
    "clipboard-list": "clipboard",
    "fi-rr-clipboard-list": "clipboard",
    "fi-clipboard-list": "clipboard",
    "clipboard-user": "clipboard",
    "fi-rr-clipboard-user": "clipboard",
    "fi-clipboard-user": "clipboard",
    "cloud-download": "download",
    "fi-rr-cloud-download": "download",
    "fi-cloud-download": "download",
    "comment": "chat",
    "fi-rr-comment": "chat",
    "fi-comment": "chat",
    "comment-alt": "chat",
    "fi-rr-comment-alt": "chat",
    "fi-comment-alt": "chat",
    "comment-sms": "chat",
    "fi-rr-comment-sms": "chat",
    "fi-comment-sms": "chat",
    "diary": "clipboard",
    "fi-rr-diary": "clipboard",
    "fi-diary": "clipboard",
    "diary-clasp": "clipboard",
    "fi-rr-diary-clasp": "clipboard",
    "fi-diary-clasp": "clipboard",
    "door-open": "logout",
    "fi-rr-door-open": "logout",
    "fi-door-open": "logout",
    "e-learning": "school",
    "fi-rr-e-learning": "school",
    "fi-e-learning": "school",
    "exclamation": "alert",
    "fi-rr-exclamation": "alert",
    "fi-exclamation": "alert",
    "exclamation-triangle": "alert",
    "fi-rr-exclamation-triangle": "alert",
    "fi-exclamation-triangle": "alert",
    "exit": "logout",
    "fi-rr-exit": "logout",
    "fi-exit": "logout",
    "file-chart-line": "chart",
    "fi-rr-file-chart-line": "chart",
    "fi-file-chart-line": "chart",
    "file-import": "upload",
    "fi-rr-file-import": "upload",
    "fi-file-import": "upload",
    "file-invoice": "receipt",
    "fi-rr-file-invoice": "receipt",
    "fi-file-invoice": "receipt",
    "fi-rr-folder": "folder",
    "fi-folder": "folder",
    "form": "clipboard",
    "fi-rr-form": "clipboard",
    "fi-form": "clipboard",
    "gas-pump": "drop",
    "fi-rr-gas-pump": "drop",
    "fi-gas-pump": "drop",
    "gavel": "badge",
    "fi-rr-gavel": "badge",
    "fi-gavel": "badge",
    "graduation-cap": "school",
    "fi-rr-graduation-cap": "school",
    "fi-graduation-cap": "school",
    "hashtag-lock": "lock",
    "fi-rr-hashtag-lock": "lock",
    "fi-hashtag-lock": "lock",
    "fi-rr-heart": "heart",
    "fi-heart": "heart",
    "heart-rate": "activity",
    "fi-rr-heart-rate": "activity",
    "fi-heart-rate": "activity",
    "house-building": "building",
    "fi-rr-house-building": "building",
    "fi-house-building": "building",
    "house-user": "home",
    "fi-rr-house-user": "home",
    "fi-house-user": "home",
    "id-badge": "badge",
    "fi-rr-id-badge": "badge",
    "fi-id-badge": "badge",
    "inventory-alt": "box",
    "fi-rr-inventory-alt": "box",
    "fi-inventory-alt": "box",
    "language": "globe",
    "fi-rr-language": "globe",
    "fi-language": "globe",
    "laptop-mobile": "device",
    "fi-rr-laptop-mobile": "device",
    "fi-laptop-mobile": "device",
    "login": "logout",
    "fi-rr-login": "logout",
    "fi-login": "logout",
    "mailbox": "mail",
    "fi-rr-mailbox": "mail",
    "fi-mailbox": "mail",
    "map-marker": "map-pin",
    "fi-rr-map-marker": "map-pin",
    "fi-map-marker": "map-pin",
    "marketplace-store": "box",
    "fi-rr-marketplace-store": "box",
    "fi-marketplace-store": "box",
    "memo-circle-check": "check-circle",
    "fi-rr-memo-circle-check": "check-circle",
    "fi-memo-circle-check": "check-circle",
    "menu-burger": "menu",
    "fi-rr-menu-burger": "menu",
    "fi-menu-burger": "menu",
    "message-code": "device",
    "fi-rr-message-code": "device",
    "fi-message-code": "device",
    "message-image": "image",
    "fi-rr-message-image": "image",
    "fi-message-image": "image",
    "message-text": "chat",
    "fi-rr-message-text": "chat",
    "fi-message-text": "chat",
    "module": "grid",
    "fi-rr-module": "grid",
    "fi-module": "grid",
    "money-bills": "rupee",
    "fi-rr-money-bills": "rupee",
    "fi-money-bills": "rupee",
    "money-check": "card",
    "fi-rr-money-check": "card",
    "fi-money-check": "card",
    "money-transfer-alt": "rupee",
    "fi-rr-money-transfer-alt": "rupee",
    "fi-money-transfer-alt": "rupee",
    "object-exclude": "layers",
    "fi-rr-object-exclude": "layers",
    "fi-object-exclude": "layers",
    "party-horn": "spark",
    "fi-rr-party-horn": "spark",
    "fi-party-horn": "spark",
    "password-alt": "key",
    "fi-rr-password-alt": "key",
    "fi-password-alt": "key",
    "password-email": "key",
    "fi-rr-password-email": "key",
    "fi-password-email": "key",
    "phone-call": "phone",
    "fi-rr-phone-call": "phone",
    "fi-phone-call": "phone",
    "plan": "clipboard",
    "fi-rr-plan": "clipboard",
    "fi-plan": "clipboard",
    "qr": "tag",
    "fi-rr-qr": "tag",
    "fi-qr": "tag",
    "rectangle-list": "list",
    "fi-rr-rectangle-list": "list",
    "fi-rectangle-list": "list",
    "resources": "layers",
    "fi-rr-resources": "layers",
    "fi-resources": "layers",
    "settings-sliders": "sliders",
    "fi-rr-settings-sliders": "sliders",
    "fi-settings-sliders": "sliders",
    "shuttle-van": "truck",
    "fi-rr-shuttle-van": "truck",
    "fi-shuttle-van": "truck",
    "signature-lock": "lock",
    "fi-rr-signature-lock": "lock",
    "fi-signature-lock": "lock",
    "sleigh": "inbox",
    "fi-rr-sleigh": "inbox",
    "fi-sleigh": "inbox",
    "sort-numeric-down": "list",
    "fi-rr-sort-numeric-down": "list",
    "fi-sort-numeric-down": "list",
    "source-data": "database",
    "fi-rr-source-data": "database",
    "fi-source-data": "database",
    "fi-rr-tag": "tag",
    "fi-tag": "tag",
    "team-check-alt": "users",
    "fi-rr-team-check-alt": "users",
    "fi-team-check-alt": "users",
    "trophy": "star",
    "fi-rr-trophy": "star",
    "fi-trophy": "star",
    "user-pen": "pencil",
    "fi-rr-user-pen": "pencil",
    "fi-user-pen": "pencil",
    "user-police": "shield",
    "fi-rr-user-police": "shield",
    "fi-user-police": "shield",
    "user-xmark": "x-circle",
    "fi-rr-user-xmark": "x-circle",
    "fi-user-xmark": "x-circle",
    "video-camera": "camera",
    "fi-rr-video-camera": "camera",
    "fi-video-camera": "camera",
    "visit": "users",
    "fi-rr-visit": "users",
    "fi-visit": "users",
    "wheelchair": "heart",
    "fi-rr-wheelchair": "heart",
    "fi-wheelchair": "heart",
    "fi-rr-wrench": "wrench",
    "fi-wrench": "wrench",
    "book-open": "book-open",
    briefcase: "briefcase",
    bus: "bus",
    "calendar-check": "calendar-check",
    "clipboard-check": "clipboard-check",
    "clipboard-list": "clipboard-list",
    "door-open": "door-open",
    "file-text": "file-text",
    "file-search": "file-search",
    "folder-open": "folder-open",
    "graduation-cap": "graduation-cap",
    hash: "hash",
    "id-card": "id-card",
    languages: "languages",
    megaphone: "megaphone",
    newspaper: "newspaper",
    "qr-code": "qr-code",
    refresh: "refresh",
    reload: "refresh",
    route: "route",
    scan: "scan",
    trophy: "trophy",
    utensils: "utensils",
    "user-check": "user-check",
    "user-minus": "user-minus",
    "user-plus": "user-plus",
    video: "video",
    wallet: "wallet",
    wifi: "wifi",
    bed: "bed",
    crown: "crown",
    library: "library",
};

export function resolveIconName(name) {
    if (!name) {
        return 'default';
    }
    const raw = String(name).trim();
    if (ICON_ALIASES[raw]) {
        return ICON_ALIASES[raw];
    }
    const stripped = raw.replace(/^fi(-rr)?-/, '');
    return ICON_ALIASES[stripped] || stripped || 'default';
}

export function iconInner(name) {
    const key = resolveIconName(name);
    return ICON_PATHS[key] || ICON_PATHS.default;
}

export function iconSvg(name, extraClass) {
    const skipFont = extraClass && String(extraClass).indexOf('sip-row-actions__glyph') !== -1;
    const base = skipFont ? 'sip-admin-svg' : 'ico icon fi';
    const cls = extraClass ? (base + ' ' + extraClass) : base;
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + iconInner(name) + '</svg>';
}

